import React, {useEffect, useState} from 'react'
import { withAppContextDecorators } from '@/common/AppContext';
import {Breadcrumb, List, Pagination} from 'antd';
import './index.less'
import api from "@/services/api";
import { useHistory } from 'react-router-dom'
import commonSetting from "@/config/commonSetting";
import { time_format_new } from '@/utils/formatTime.js'

const NewsTrends = (props) => {
    const history = useHistory()
    const [newsList,setNewsList] = useState();
    const [totalData,setTotalData] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
        size: 6,
    })
    const getNewsList = async ()=>{
        let resp = await api.pubTeamController.publicTeamArticlesDailyByNumberUsingGET({
            teamNumber:'xwdt',
            current: pagination.current,
            size: pagination.size
        })
        if( resp.code == 0){
            setNewsList(resp.data)
            setTotalData(resp.pagination.total)
        }
    }
    const toDetail = (item)=>{
        history.push({
            pathname:'/gcInfo/detail',
            search:`?number=${item.number}&key=1`
        })
    }
    useEffect(()=>{
        getNewsList()
    },[pagination.current])


    return <div id="newsTrends">
        <div className={'breadcrumb-con warp'}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/index'})}}>首页</Breadcrumb.Item>
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/gcInfo'})}}>国诚资讯</Breadcrumb.Item>
                <Breadcrumb.Item>新闻动态</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div className={'centerBox warp box-h'}>
            {
                newsList && newsList.length > 0 ?
                    <List
                        itemLayout="vertical"
                        size="large"
                        pagination={{
                            onChange: (page ,pageSize) => {
                                console.log(page ,pageSize);
                                setPagination(item =>{
                                    return {
                                        ...item,
                                        current: page,
                                        pageSize: pageSize
                                    }
                                })
                            },
                            showSizeChanger:false,
                            pageSize: pagination.size,
                            total: totalData,
                            current: pagination.current,
                        }}
                        dataSource={newsList}

                        renderItem = {(item) =>(
                            <List.Item
                                key={item.id}
                                onClick={()=>{toDetail(item)}}
                            >
                                <img
                                    width={420}
                                    height={260}
                                    src={ commonSetting.OSS_URL + item.titleImageUrl}
                                />
                                <div className={'list-con'}>
                                    <div className={'list-title'}>
                                        <h2>{item.title}</h2>
                                        <div className={'line'}></div>
                                    </div>
                                    <div className={'list-describe'}>{item.brief}</div>
                                    <p>{time_format_new(item.createTime)}</p>
                                </div>

                            </List.Item>
                        )}
                    >

                    </List> :  <></>
            }


        </div>
    </div>
}
export default withAppContextDecorators(NewsTrends)
